import { ref, computed, onMounted, onUnmounted, getCurrentInstance } from 'vue'

export function useRegistroPreventa() {
    const instance = getCurrentInstance()
    const store = instance.proxy.$store

    const registro = ref({
        name: '',
        surnames: '',
        tipoDocumentoSeleccionado: null,
        nif: '',
        telefono: '',
        pais: null,
        pais_id: null,
        provincia: null,
        province_id: null,
        localidad: null,
        location_id: null,
        n_entradas: null
    })
    const windowWidth = ref(typeof window !== 'undefined' ? window.innerWidth : 1024)

    const tiposDocumento = [
        { type: "DNI", value: "" },
        { type: "NIE", value: "" },
        { type: "NIF", value: "" },
        { type: "PASAPORTE", value: "" },
        { type: "OTROS", value: "" }
    ]

    const esMovil = computed(() => windowWidth.value <= 768)
    const user = computed(() => store.getters.getUser)

    const inicializarRegistro = () => {
        registro.value.name = user.value?.name ?? ''
        registro.value.surnames = user.value?.surnames ?? ''
        registro.value.tipoDocumentoSeleccionado = tiposDocumento.find(tipo => tipo.type === 'DNI')
        registro.value.nif = user.value?.nif ?? ''
        registro.value.telefono = user.value?.telefono ?? ''
        registro.value.location_id = user.value?.location_id ?? null
        registro.value.localidad = user.value?.localidad ?? null
        registro.value.province_id = user.value?.province_id ?? null
        registro.value.provincia = user.value?.provincia ?? null
    }

    const updateWindowWidth = () => {
        if (typeof window !== 'undefined') {
            windowWidth.value = window.innerWidth
        }
    }

    onMounted(() => {
        inicializarRegistro()
        if (typeof window !== 'undefined') {
            windowWidth.value = window.innerWidth
            window.addEventListener('resize', updateWindowWidth)
        }
    })

    onUnmounted(() => {
        if (typeof window !== 'undefined') {
            window.removeEventListener('resize', updateWindowWidth)
        }
    })

    return {
        registro,
        esMovil
    }
}
